import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import GlobalMarkupOptions from '@nerdwallet/coin/GlobalMarkupOptions';
import DocumentTitle from 'react-document-title';

import { Button, Type } from '@nerdwallet/currency';

import { CAREERS_TEAMS_PATH } from '~/client/lib/employee-branding/careers-breadcrumbs-paths';

const NotFound = ({ errorType }) => {
  const errorButtonCopy =
    errorType === 'department'
      ? 'See current departments'
      : 'See current open positions';

  return (
    <Fragment>
      <GlobalMarkupOptions>
        {{
          theme: 'company',
        }}
      </GlobalMarkupOptions>
      <DocumentTitle title="Not Found | NerdWallet" />
      <div
        className={classNames([
          classes('width-auto'),
          classes('text-align-center'),
          classes('margin-vertical-5'),
          classes('margin-horizontal-3'),
        ])}
      >
        <Type
          chronicle
          size="4"
          className={classNames([
            classes('display-block'),
            classes('max-width-prose-wide'),
            classes('margin-horizontal-auto'),
            classes('margin-bottom-3-half'),
            classes('margin-bottom-4--wide'),
          ])}
        >
          That {errorType} was not found
        </Type>
        <Button primary href={CAREERS_TEAMS_PATH}>
          {errorButtonCopy}
        </Button>
      </div>
    </Fragment>
  );
};

NotFound.displayName = 'Not Found';

NotFound.propTypes = {
  errorType: PropTypes.string,
};

export default NotFound;
